import React from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PatientSearchResultsContent from '../pageContent/PatientSearchResults.content'
import { useDispatch, useSelector } from 'react-redux'
import { setIsSearchImport } from '../store/patientSearch.actions'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { newPtClick } from '../../../utilities/patientSearch.util'
import { IPatientSearchState } from '../store/patientSearch.types'
import { getPatientSearchState } from '../selectors'

const PatientSearchResults: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const patientSearchState: IPatientSearchState = useSelector(getPatientSearchState)
  const { showImportDataConfirmationAlert } = patientSearchState
  const onBackClick = () => {
    history.push(TabConstants.PATIENT_SEARCH)
  }

  const onNewPtClick = () => {
    dispatch(setIsSearchImport(true))
    newPtClick(dispatch, showImportDataConfirmationAlert, t, patientSearchState, history)
  }

  return (
    <IonPage id='PatientSearchResultsPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('patientSearch.patientSearch')}
        isBackButton={true}
        nextLabel={t('patientSearch.newPatient')}
        nextOnClick={onNewPtClick}
      />
      <IonContent color='light'>
        <PatientSearchResultsContent />
      </IonContent>
    </IonPage>
  )
}

export default PatientSearchResults
